<template>
    <Teleport to="body">
      <div v-if="visible" class="modal-overlay">
        <div class="modal">
          <div class="modal-header">
            <slot name="header"><p>{{ infoTitle }}</p></slot>
          </div>
          <div class="modal-divider">
              <div class="divider-line"></div>
          </div>
          <div class="modal-body">
            <slot name="body"><p>{{ infoMessage }}</p></slot>
          </div>
          <div class="modal-footer">
            <button @click="close"><p>Close</p></button>
          </div>
        </div>
      </div>
    </Teleport>
  </template>
  
  <script>
  export default {
    name: 'ModalBox',
    props: {
      visible: {
        type: Boolean,
        required: true
      },      
      infoTitle: {
        type: String,
        default: 'Default title'
      },
      infoMessage: {
        type: String,
        default: 'Default message'
      }
    },
    methods: {
      close() {
        this.$emit('close')
      }
    }
  }
  </script>
  
  <style>
  .modal-overlay {
    position: fixed !important;
    top: 0 !important;
    left: 0 !important;
    width: 100% !important;
    height: 100% !important;
    background: rgba(0, 0, 0, 0.5) !important;
    display: flex !important;
    justify-content: center !important;
    align-items: center !important;
    z-index: 999999 !important;
  }
  .modal {
    background: var(--card-bg) !important;
    padding: 20px !important;
    border-radius: 5px !important;
    box-shadow: 0 2px 10px var(--shadow-color) !important;
    width: 400px !important;
    max-width: 100% !important;
    text-align: center !important;
    position: relative !important;
    z-index: 1000000 !important;
  }
  .modal-header,
  .modal-body,
  .modal-footer {
    margin-bottom: 20px;
  }
  .modal-divider {
    margin-bottom: 30px;
  }
  .divider-line {
    height: 3px;
    border-top: 1px solid #e0e0e0;
    background-color: red;
  }
  .modal-footer {
    display: flex;
    justify-content: flex-end;
  }
  </style>
  